import { GET_SERVICE_SEARCH_DEVICE_SUCCESS } from "../actions/servicesAction"


const scheduleDeviceReducer = (state = [], { type,  payload=[] }) => {
    switch (type) {
      case GET_SERVICE_SEARCH_DEVICE_SUCCESS:
        return payload
      default:
        return state
    }
  }
  
  export default scheduleDeviceReducer